var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-container",class:{ 'dark-mode': _vm.darkMode }},[(_vm.showAlertCard)?_c('alert-card-component',{staticClass:"alert-card-component",attrs:{"data":_vm.alertCardData},on:{"hideCard":_vm.hideAlertCard}}):_vm._e(),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }